module.exports = __webpack_public_path__ + "img/xingxing.367c5ec7.png";